import React, { useState } from "react";
import { useRegisterMutation } from "../slices/usersApiSlice";
import { setCredentials } from "../slices/authSlice";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const RegistrationScreen = () => {
  const [registration] = useRegisterMutation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [name, setName] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { userInfo } = useSelector((state) => state.auth);

  const redirect = "/";

  useEffect(() => {
    if (userInfo) {
      navigate(redirect);
    }
  }, [userInfo, redirect, navigate]);

  const submitHandler = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    } else {
      try {
        const data = { name, email, password };
        const res = await registration(data).unwrap();
        dispatch(setCredentials({ ...res }));
        toast("Registration Successful");
        navigate(redirect);
      } catch (error) {
        toast.error(error.message || "An error occurred");
      }
    }
  };

  return (
    <div>
      <div className="grid grid-rows-3 items-center justify-center">
        <h2 className="text-4xl md:text-5xl text-center ">
          Register
        </h2>
        <form
          onSubmit={submitHandler}
          className="flex flex-col font-semibold  gap-3"
        >
          <label htmlFor="name">Name</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            id="name"
            name="name"
            placeholder="Enter Name"
            className="w-96 font-light rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-primaryYellow focus:border-transparent"
          />
          <label htmlFor="email">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            id="email"
            name="email"
            placeholder="Enter Email"
            className="w-96 font-light rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-primaryYellow focus:border-transparent"
          />
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            name="password"
            placeholder="Enter Password"
            className="w-96 font-light rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-primaryYellow focus:border-transparent"
          />
          <label htmlFor="confirmpassword">Confirm Password</label>
          <input
            type="password"
            id="confirm-password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            name="password"
            placeholder="Enter Password"
            className="w-96 font-light rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-primaryYellow focus:border-transparent"
          />
          <button
            type="submit"
            className="md:w-96 h-9 w-96 nav-links md:static text-black text-left flex p-5 mt-5 font-semibold items-center
           bg-primaryYellow rounded-lg hover:opacity-50"
          >
            <div className="w-full grid grid-cols-2 items-center">
              <div className="self-center">
                <p className="mt-1 text-sm">REGISTER</p>
              </div>
              <div className="flex items-center justify-end text-sm">
                <ion-icon name="arrow-forward-circle-outline"></ion-icon>
              </div>
            </div>
          </button>
        </form>
        <a
          href="/login"
          className="text-center mt-5 underline text-lg font-semibold"
        >
          Already have an account? Login Here
        </a>
      </div>
    </div>
  );
};
export default RegistrationScreen;
